import { Grid, Typography } from "@mui/material";
import { useContext } from "react";
import RhfRadioGroup from "../../../../libs/rhf-mui/RhfRadioGroup";
import { SpwkUtil } from "../../../dao/SpwkUtil";
import { UniOption } from "../../../dao/UniOption";
import { UniQuestion } from "../../../dao/UniQuestion";
import { FrmSpwkQuestionnaire_Context } from "../index";
import { R } from "../../../R";
import UcOption from "./UcOption";
import RhfErrorText from "../../../../libs/rhf-mui/RhfErrorText";
import { Member } from "../../../dao/Member";
import { useTranslation } from "react-i18next";

type Props = {
  question: UniQuestion | undefined;
  options: UniOption[];
  member: Member | null | undefined;
};

const UcQuestion = ({ question, options, member }: Props) => {
  const { t } = useTranslation();
  const mFrmSpwkQuestionnaire_Context = useContext(
    FrmSpwkQuestionnaire_Context
  );

  const COLOR_TITLE = R.color.primary;

  function product_heading(question: UniQuestion | undefined) {
    if (question === undefined) {
      return;
    }

    if (question.kind === SpwkUtil.KIND_標題) {
      if (question.variant === "h6") {
        let variant_value: any = "h5";
        return (
          <Grid
            item
            sx={{ borderLeft: 10, borderColor: COLOR_TITLE }}
            xs={12}
            key={question.question_code}
          >
            <Typography
              variant={variant_value}
              sx={{ paddingLeft: "12px" }}
              className="uc_title"
              id={question.question_title}
            >
              {t(question.question_title)}
            </Typography>
          </Grid>
        );
      } else if (question.variant === "subtitle2") {
        let variant_value: any = "h6";
        return (
          <Grid item xs={12} key={question.question_code}>
            <Typography variant={variant_value}>
              {t(question.question_title)}
            </Typography>
          </Grid>
        );
      } else {
        return (
          <Grid
            item
            sx={{ color: COLOR_TITLE, fontWeight: "bold" }}
            xs={12}
            key={question.question_code}
          >
            {t(question.question_title)}
          </Grid>
        );
      }
    } else {
      return (
        <Grid
          item
          sx={{ color: COLOR_TITLE, fontWeight: "bold" }}
          xs={12}
          key={question.question_code}
        >
          {t(question.question_title)}
        </Grid>
      );
    }
  }

  function Product_question(
    question: UniQuestion | undefined,
    options: UniOption[]
  ) {
    if (question === undefined) {
      return;
    }

    return (
      <Grid container>
        {product_heading(question)}

        <Grid item xs={12} key={question.question_code + "LangB"}>
          <Typography variant="subtitle1">
            {question.getTitleLangB(mFrmSpwkQuestionnaire_Context?.LangB ?? "")}
          </Typography>
        </Grid>
        <RhfErrorText name={question.question_code} className="fs-4" />

        {/* 產生options */}
        <Grid item xs={12}>
          {question.kind === SpwkUtil.KIND_單選 ? (
            <Grid item key={question.question_code}>
              <RhfRadioGroup name={question.get_Question_RhfName()}>
                <Grid item container rowSpacing={{ xs: 3 }}>
                  {options.map((option) => (
                    <UcOption
                      option={option}
                      key={option.guid}
                      member={member}
                    />
                  ))}
                </Grid>
              </RhfRadioGroup>
            </Grid>
          ) : (
            <Grid
              item
              container
              rowSpacing={{ xs: 2 }}
              xs={12}
              key={question.question_code}
            >
              {options.map((option) => (
                <UcOption option={option} key={option.guid} member={member} />
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
  return <Grid item>{Product_question(question, options)}</Grid>;
};

export default UcQuestion;
